<!-- 话题详情 -->
<template>
<div class="subject">
    <Header class="media-query-pc" />
    <MediaHeader class="media-query-m" />
    <div class="subject-wrap">
        <div class="g-l">
            <div class="detail-container" :class="{'has-bg':detail.content.length>0,'has-cover':detail.coverImage.length>0}">
                <div class="lf-cont">
                    <div class="title"> 
                        <span class="ico">#</span>
                        <span v-if="detail.closed == 0"> {{detail.title}}</span>
                        <span v-else> 此话题已关闭</span>
                    </div>
                    <div class="description" v-if="detail.content"><div class="box">{{detail.content}}</div></div>
                    <div class="static-cont">
                        <div>浏览量 {{detail.view}}</div>
                        <div>信息量 {{detail.postCount}}</div>
                    </div>
                </div>
                <div class="cover-cont" v-if="detail.coverImage">
                    <img :src="detail.coverImage" alt="">
                </div>
            </div>
            <div class="tab">
                <div class="flex-cont">
                    <div class="type-item" :class="{active:type == 1}" @click="tabChange(1)">推荐</div>
                    <div class="type-item" :class="{active:type == 2}" @click="tabChange(2)">最新</div>
                </div>
                <a v-if="detail.closed == 0" class="join-subject" @click="postLink($event)" :href="'/publish/travel?subject='+params.id|hostBuild('forum')" target="_blank"><i class="el-icon-edit"></i> 参与话题</a>
            </div>

            <div class="post-cont">
                <template v-for="(item,index) in list">
                    <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                    <SubjectCmsItem :data="item" :key="item.id" v-if="item.app == 'cms_post'" />
                    <SubjectPostItem :data="item" :key="item.id" v-if="item.app == 'bbs_post'" @attention="attention" />
                </template>
                
            </div>
            <template v-if="pageComplete && list.length==0">
                <div class="no-data">
                    <img :src="require('@/assets/images/no-data.png')" height="100" alt="">
                    <div class="text">暂无相关内容</div>
                </div>
            </template>
            <template v-else>

                <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
                <div class="loading-style" v-if="!hasMore" >没有更多了</div>
            </template>
        </div>
        <div class="g-r">
            <HotSubject />
            <!-- <RelatedSubject :subjectId="params.id" /> -->
        </div>
    </div>
    <DiscussionShare :data="detail" class="share-warp" v-if="detail.closed == 0" />
</div>
</template>
<script>
import Header from '@/components/header/header.vue'
import MediaHeader from '@/components/header/media-header.vue'
import SubjectCmsItem from './subject-cms-item.vue'
import SubjectPostItem from './subject-post-item.vue'
import HotSubject from './hot-subject.vue'
import { isScrollToPageBottom ,inflowAdvConvert,setHtmlMeta} from '@/utils/utils';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
//import RelatedSubject from './related-subject.vue'
import { throttle } from 'throttle-debounce';
import DiscussionShare from './discussion-share.vue'
export default {
    name:'SubjectDetail',
    components:{Header,SubjectCmsItem,SubjectPostItem,HotSubject,YorkbbsInfoflowItem,DiscussionShare,MediaHeader},
    data(){
        return  {
            
            detail:{
                id:'',
                coverImage:'',
                title:'',
                content:'',
                view:0,
                postCount:0,
                thumbUpTotal:0,
                favorite:0,
                isFavorite:0,
                hasGivenThumbUp:0,
                closed:0,
                seoDescription:'',
                seoKeyword:'',
                seoTitle:'',
            },
            params:{
                id:'',
                offset:1,
                size:10,
            },
        
            list:[],
            type:1,
            pageComplete:false,
            hasMore:true,
            listLoading:true,
        }
    },
    computed:{
        
    },
    created(){
        this.params.id = this.$route.params.id;
        this.getSubjectDetail();
        this.getList();
        
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        async getSubjectDetail(){
            let result = await this.$axios.post('/subject/v1/subject/get/detail',{id:this.params.id});
            console.log(result);
            if( result.code == 0 ){
                if( result.data.subject.closed == 0){
                    for(var key in this.detail){
                        this.detail[key] = result.data.subject[key];
                    }
                    setHtmlMeta({
                        title:this.detail.seoTitle||'约克论坛 - 加拿大第一中文网', 
                        keywords:this.detail.seoKeyword||'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛', 
                        description:this.detail.seoDescription||'约克论坛（yorkbbs.ca）是加拿大排名第一的中文网站，是多伦多最具影响力的中文网络媒体。为多伦多华人和留学生提供加拿大新闻、房产、汽车、黄页、美食、旅游、留学移民、财经、招聘、二手、活动优惠等生活信息。'
                    })
                }else{
                    this.detail.closed = 1;
                }
            }
            
        },
        tabChange(index){
            if( this.type == index) return false;
            this.pageComplete = false;
            this.type = index;
            this.params.offset = 1;
            this.getList();
        },
        async getList(){
            this.listLoading = true;
            
            if( this.params.offset == 1 ){
                this.list = [];
            }
            if( this.type == 1 ){
                let result = await this.$axios.post('/subject/v1/post/list/recommended',this.params);
               
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
                this.detail.postCount = result.data.itemTotal;
              
            }else{
                let result = await this.$axios.post('/subject/v1/post/list/latest',this.params);
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
                
            }
           
            console.log(this.hasMore);
            this.pageComplete = true;
            this.listLoading = false;
        },
         pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
        }),
        async getNewsList(){
            let result = await this.$axios.post('/cms/v1/get/news/mainpage/hot/post',{offset:1,size:10});
            this.list = result.data.items;
        },
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'5238de03-c0cd-4aba-b8a3-d60e8987d11e',
                    subject:this.params.id,
                    name:'机票旅游'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        },
        attention(obj){
            
            for(var i=0; i<this.list.length;i++){
                if(this.list[i].app != 'bbs_post') continue;
                if( this.list[i].user.id == obj.id){
                    this.list[i].user.focusedByMe = obj.val;
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.subject-wrap{
    display: flex; width:990px; margin:30px auto 0;
    .g-r{
        width:300px; margin-left: 40px;
    }
    .g-l{
        flex:1; overflow: hidden;
    }
    .detail-container{
        display: flex; border-radius: 10px; overflow: hidden;  margin-bottom: 40px;
        &.has-bg{
            background: url(./assets/bg.png) no-repeat; background-size:100% 100% ;
            .lf-cont{padding: 25px 10px 25px 30px;}
        }
        &.has-cover{
            background: #f8f8f8;
            .lf-cont{padding: 25px 20px 25px 30px;
                
            }
        }
        .cover-cont{
            width:50%;position: relative; font-size: 0;
            &:after{
                content: ''; display: block; padding-bottom: 75%;
            }
            img{position: absolute; left: 0; top: 0; width:100%; height: 100%; object-fit: cover;}
        }
        .lf-cont{
            flex:1; overflow: hidden; display: flex; flex-direction: column;
            
            .title{
                margin-bottom: 15px;font-weight:bold;
                span{ vertical-align: middle;}
                .ico{display: inline-block; vertical-align: middle; width:24px; line-height: 24px; height: 24px; text-align: center; font-size: 16px; color: #fff; background: #e43a3a; border-radius: 50%; font-weight: normal; margin-right: 5px;}
                font-size: 24px; line-height: 36px;
            }
            .static-cont{
                display: flex; align-items: center; color: #999; font-size: 14px; line-height: 20px; margin-top: 20px;
                div{margin-right: 20px;}
            }
            .description{
                flex:1; overflow: hidden; 
                .box{
                    text-overflow: ellipsis; font-size: 14px; line-height: 24px; color: #666;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    overflow: hidden;
                }
            }
        }
    }
    .tab{
        display: flex; align-items: center; margin-bottom: 30px;
        .flex-cont{
            flex:1;display: flex; align-items: center;
            .type-item{
                font-size: 18px; line-height: 24px; color: #999; margin-right: 30px; user-select: none; cursor: pointer;
                &.active{font-size: 20px; line-height: 28px; color: #111; font-weight: bold;}
            }
        }
        .join-subject{
            display: flex; align-items: center; height: 36px; background: #e43a3a; color: #fff; font-size: 14px; border-radius: 4px; padding: 0 10px; user-select: none; cursor: pointer;
            i{margin-right: 3px;}
            &:hover{opacity: 0.8;}
        }
    }

    .no-data{
        text-align: center; padding-top: 50px;
        img{margin-bottom: 20px;}
        .text{font-size: 16px; color: #999;}
    }
}
.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}

@media screen and (max-width:768px){
    .subject-wrap{
        width:100%; margin-left: 0; margin-right: 0; margin-top: 40px;
        .detail-container{
            margin-bottom: 20px;
            .lf-cont{
                margin: 0 15px; display: block;
                .title{margin-top: 15px;}
                .description{margin-bottom: 15px;}
                .static-cont{margin-top: 0;}
            }
            &.has-bg{
                background: none;
                .lf-cont{
                    padding: 0;
                    .title{margin-bottom: 10px;}
                   
                    .description{font-size: 14px; line-height: 24px; color: #666;}
                }
            }
            &.has-cover{
                position: relative; display: block; border-radius: 0;
                .lf-cont{
                    position: absolute; z-index: 5; left: 0; bottom: 0; right: 0; margin: 0; padding: 0 15px 20px;
                    background: linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,0.8));
                    .title{
                        color: #fff;
                    }
                    .description{
                        color: #fff;
                        .box{-webkit-line-clamp: 3; color: #ccc;}

                    }
                    .static-cont{color: #ccc;}
                }
                .cover-cont{width: 100%;}
            }
        }
        .g-r{display: none;}
        .join-subject{
            position: fixed; z-index: 20;
            left: 50%; bottom: 50px; transform: translateX(-50%);
            height: 40px !important; padding: 0 20px !important; border-radius: 20px !important;
        }
        .tab{
            margin-bottom: 20px;
            .flex-cont{
                padding: 0 15px;position: relative;
                &:after{content:''; position: absolute; left: 0; bottom: 0; right: 0; height: 1px; background: #eee;}
                .type-item{
                    font-size: 14px; line-height: 20px; color: #999; position: relative; padding-bottom: 5px;
                    

                    &.active{
                        position: relative; z-index: 2;
                        font-size: 16px;
                        &:after{content:''; position: absolute; z-index: 5; left: 0; bottom: 0; right: 0; height: 2px; background: #e43a3a;}
                    }
                }
            }
        }
        .post-cont{margin: 0 15px;}
        .share-warp{display: none;}
    }
}

@media screen and (max-width:768px){
    .media-query-pc{display: none;}
    .media-query-m{display:block;}
}
@media screen and (min-width:768px){
    .media-query-pc{display: block;}
    .media-query-m{display:none;}
}
</style>